import React from "react";

import "./request_total_card.less";
import { Skeleton } from "antd";

interface RequestTotalCardProps {
  label: string;
  total: number;
  color?: string;
  isLoading?: boolean;
}

const RequestTotalCard: React.FC<RequestTotalCardProps> = ({
  label,
  total,
  isLoading,
  color,
}) => {
  return (
    <div className="request-total-card" style={{ backgroundColor: color }}>
      <Skeleton loading={isLoading} active paragraph={{ rows: 1 }}>
        <div className="request-total-card__header">{label}</div>
        <label className="request-total-card__label">{total}</label>
      </Skeleton>
    </div>
  );
};

export default RequestTotalCard;
